/* unplugin-vue-components disabled */import { render } from "./RechargeAgreement.vue?vue&type=template&id=ed3cbc62&scoped=true"
import script from "./RechargeAgreement.vue?vue&type=script&lang=js"
export * from "./RechargeAgreement.vue?vue&type=script&lang=js"

import "./RechargeAgreement.vue?vue&type=style&index=0&id=ed3cbc62&lang=scss&scoped=true"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3cbc62"]])

export default __exports__